import React from "react";
import { education } from "../data";
import "./PageStyles.css";

const EducationPage = () => (
  <div className="page">
    <header className="page-header">
      <h1 className="section-title">Education</h1>
      <p className="page-lead">Academic background and credentials.</p>
    </header>
    <section className="section">
      <div className="container">
        <div className="education-list">
          {education.map((edu) => (
            <div key={edu.id} className="education-card">
              <div className="education-header">
                <div>
                  <h3 className="education-degree">{edu.degree}</h3>
                  <p className="education-university">{edu.university}</p>
                </div>
                <div className="education-meta">
                  <span className="education-duration">{edu.duration}</span>
                  <span className="education-location">{edu.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default EducationPage;

